import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from '@/common/types/errorResponse';
import { AxiosResponse } from 'axios';

interface UseCreateEstablishmentUserExternalToken {
  establishmentUserId?: string;
  onSuccess?: (reponse: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

const useCreateEstablishmentUserExternalToken = ({ establishmentUserId, onSuccess, onError }: UseCreateEstablishmentUserExternalToken) => {
  const privateAxios = usePrivateAxios();

  return useMutation<AxiosResponse, ErrorResponse>({
    mutationKey: ['createEstablishmentUserExternalToken', establishmentUserId],
    mutationFn: () => privateAxios.post(`/establishment/user_external_tokens`, {
      user_external_token: {
        user_id: establishmentUserId,
      },
    }),
    onSuccess,
    onError,
  });
};

export default useCreateEstablishmentUserExternalToken;
